import { ADMIN_PANEL, ADMIN_PANEL_LOGIN } from '@/constants/adminPanelRoutes';
import adminPanelService from '@/services/adminPanel';

export default function checkAdminPanelNonAuth({ to }) {
  if (adminPanelService.hasAuthTokens() && to.name === ADMIN_PANEL_LOGIN) {
    return { name: ADMIN_PANEL };
  }

  return true;
}
